import { render, staticRenderFns } from "./UnattestesBuilding.vue?vue&type=template&id=09ca0530&scoped=true&"
import script from "./UnattestesBuilding.vue?vue&type=script&lang=js&"
export * from "./UnattestesBuilding.vue?vue&type=script&lang=js&"
import style0 from "./UnattestesBuilding.vue?vue&type=style&index=0&id=09ca0530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ca0530",
  null
  
)

export default component.exports